import { render } from "./CreateCard.vue?vue&type=template&id=3fbe82a8&scoped=true"
import script from "./CreateCard.vue?vue&type=script&lang=js"
export * from "./CreateCard.vue?vue&type=script&lang=js"

import "./CreateCard.vue?vue&type=style&index=0&id=3fbe82a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbe82a8"]])

export default __exports__